import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es seguro usar con preservativos?',
    a: 'Sí, está formulado para ser compatible con látex y otros materiales de preservativos.'
  }, {
    q: '¿Anestesia o estimula?',
    a: 'Estimula. No adormece, sino que intensifica la sensación mientras ayuda a manejar mejor el momento.'
  }, {
    q: '¿Cuánto dura el efecto?',
    a: 'Depende de cada persona, pero en promedio entre 20–40 minutos de sensación mejorada.'
  }, {
    q: '¿Se puede usar solo o en pareja?',
    a: 'Ambos. Podés usarlo para masturbación o en relaciones con pareja.'
  }, {
    q: '¿Tiene olor fuerte?',
    a: 'No. El gel tiene aroma suave y se absorbe rápido sin dejar residuos evidentes.'
  }, {
    q: '¿Cuánto tarda en llegar?',
    a: '48–72 horas hábiles en CABA/GBA. Resto del país: 5–7 días. Envío gratis a todo el país.'
  }, {
    q: '¿Viene el envío identificado?',
    a: 'No. Envío 100% discreto, sin etiquetas ni referencias al producto en la caja.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí: 180 días con cambio directo si no te convence o tenés algún inconveniente.'
  }];
  return <section className="w-full bg-dark-900 py-24 px-4" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-61">
          PREGUNTAS FRECUENTES
        </motion.h2>

        <div className="space-y-4" data-id="element-62">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-63" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.05
  }} className={`border rounded-lg overflow-hidden transition-colors duration-300 ${isOpen ? 'border-gold-500/50 bg-dark-800' : 'border-white/10 bg-dark-800/50'}`} data-id="element-64">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-65">
        <span className={`font-bold text-lg ${isOpen ? 'text-gold-500' : 'text-white'}`} data-id="element-66">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-gold-500' : 'text-gray-500'}`} data-id="element-67" />
      </button>

      <AnimatePresence data-id="element-68">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-69">
            <div className="p-5 pt-0 text-gray-400 leading-relaxed border-t border-white/5" data-id="element-70">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}